import { Component, OnInit } from '@angular/core'
import { HomeUrlService } from 'framework/home-url/home-url.service'

@Component({
    templateUrl: './celebrate.component.html',
    styleUrls: ['./celebrate.component.scss'],
})
export class CelebrateComponent implements OnInit {
    homeUrl: string = '/'

    constructor(private homeUrlService: HomeUrlService) {}

    ngOnInit(): void {
        this.homeUrl = this.homeUrlService.getHomeUrl()
    }
}
